import * as React from 'react';
import { RichText } from 'prismic-reactjs';

import { Grid, Notification, WithStyles, withStyles } from '@nelnet/unifi-components-react';

import styles from './styles';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Error, Info } from '@material-ui/icons';

interface IUsageNotificationProps extends WithStyles<typeof styles> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  usage_notification_items?: Array<any>;
}

const UsageNotification: React.FunctionComponent<IUsageNotificationProps> = ({
  classes,
  usage_notification_items,
}) => {
  if (usage_notification_items) {
    return (
      <Grid container padding={{ top: 1, bottom: 1 }}>
        {usage_notification_items.map((usage_item, i) => {
          const notification_type = usage_item.notification_type;
          const notification_content_body = usage_item.notification_content;
          if (notification_content_body) {
            return (
              <React.Fragment key={i}>
                <Grid item xs={12} margin={{ bottom: 2 }}>
                  <Notification
                    type={notification_type == 'Error' ? 'error' : 'info'}
                    icon={notification_type == 'Error' ? <Error /> : <Info />}
                    iconLabel={notification_type == 'Error' ? 'Alert' : 'Info'}
                    margin={{ top: 2 }}
                  >
                    <div className={classes.notificationContainer}>
                      {RichText.render(notification_content_body)}
                    </div>
                  </Notification>
                </Grid>
              </React.Fragment>
            );
          }
        })}
      </Grid>
    );
  }
};

export default withStyles(styles)(UsageNotification);
